module.exports = __webpack_public_path__ + "media/images/redesign-images/sorority/title-sorority-dde1c9364ec8673879d0d3d88ee9a2d8.svg";